<template>
    <div v-if="motm != null && top3.length > 0" class="teaser-b">
        <div v-if="votingOpen" class="teaser-b-badge teaser-b-badge--live">
            <span class="teaser-b-badge-dot"></span>
            Abstimmung läuft
        </div>
        <div v-else-if="motm.isFinal" class="teaser-b-badge teaser-b-badge--closed">
            Abstimmung beendet
        </div>

        <span class="teaser-b-title">🏆 Spieler des Spieltags</span>

        <div class="teaser-b-list">
            <div v-for="(player, idx) in top3" :key="idx" class="teaser-b-row" :class="{ 'teaser-b-row--first': idx === 0 }">
                <div class="teaser-b-fill" :style="{ width: player.percentage + '%' }"></div>
                <div class="teaser-b-content">
                    <span class="teaser-b-rank">{{ idx === 0 ? '🏆' : (idx + 1) + '.' }}</span>
                    <span class="teaser-b-name">{{ player.displayName }}</span>
                    <b class="teaser-b-pct">{{ player.percentage }}%</b>
                </div>
            </div>
        </div>

        <div v-if="votingOpen" class="teaser-b-btn-row">
            <a :href="discordVoteLink" target="_blank" rel="noopener" class="modern-btn">Zur Abstimmung</a>
        </div>

        <div class="teaser-b-footer">
            <span><b>{{ motm.totalVotes }}</b> Stimmen</span>
            <span v-if="!motm.isFinal" class="teaser-b-updated" :title="'Letztes Update: ' + lastUpdate">
                <font-awesome-icon icon="clock" /> {{ lastUpdate }}
            </span>
        </div>
    </div>
</template>

<script>
import * as utils from '../utils.js';

export default {
    props: {
        motm: {
            type: Object,
            default: null
        }
    },
    computed: {
        top3() {
            return this.motm?.top?.slice(0, 3) || [];
        },
        lastUpdate() {
            return utils.formatRelativeTime(this.motm?.votesUpdatedAt);
        },
        votingOpen() {
            return this.motm?.isFinal === false;
        },
        discordVoteLink() {
            return process.env.VUE_APP_MOTM_DISCORD_LINK;
        }
    }
}
</script>

<style scoped>
.teaser-b {
    position: relative;
    text-align: left;
    background: var(--secondary-bg);
    border: 1px solid var(--card-border);
    border-radius: var(--radius-md);
    padding: var(--spacing-sm);
    padding-top: 26px;
}

/* Gleiche Badge-Sprache wie in ShowMotm.vue, nur kleiner skaliert fuer den kompakten Teaser. */
.teaser-b-badge {
    position: absolute;
    top: -10px;
    left: var(--spacing-sm);
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: var(--fs-sm);
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 999px;
    white-space: nowrap;
}

.teaser-b-badge--live {
    background: var(--error);
    color: var(--text-primary);
    box-shadow: var(--shadow-md);
}

.teaser-b-badge--closed {
    background: var(--card-bg);
    color: var(--text-secondary);
    border: 1px solid var(--card-border);
}

.teaser-b-badge-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--text-primary);
    animation: teaser-b-pulse 1.5s ease-in-out infinite;
}

@keyframes teaser-b-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
    }

    70% {
        box-shadow: 0 0 0 5px rgba(255, 255, 255, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
}

.teaser-b-title {
    display: block;
    font-size: var(--fs-base);
    font-weight: 600;
    margin-bottom: 8px;
}

.teaser-b-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.teaser-b-row {
    position: relative;
    height: 22px;
    border-radius: var(--radius-sm);
    background: var(--card-bg);
    overflow: hidden;
    opacity: 0.8;
}

.teaser-b-row--first {
    height: 28px;
    opacity: 1;
}

/* Gleiche Akzentfarbe wie ShowMotm.vue :.motm-fill - siehe Kommentar dort. */
.teaser-b-fill {
    position: absolute;
    inset: 0;
    background: var(--accent-primary);
}

.teaser-b-content {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 10px;
    font-size: var(--fs-sm);
}

.teaser-b-rank {
    flex-shrink: 0;
    font-weight: 700;
    width: 1.2em;
    text-align: center;
}

.teaser-b-name {
    flex: 1 1 auto;
    min-width: 0;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.teaser-b-row--first .teaser-b-name {
    font-weight: 700;
}

.teaser-b-pct {
    flex-shrink: 0;
    margin-left: 8px;
}

.teaser-b-btn-row {
    margin-top: 10px;
}

.teaser-b-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    font-size: var(--fs-sm);
}

.teaser-b-updated {
    color: var(--text-secondary);
    font-size: var(--fs-sm);
}
</style>
